import { render, staticRenderFns } from "./positionAdd.vue?vue&type=template&id=c23f2a7e&scoped=true"
import script from "./positionAdd.vue?vue&type=script&lang=js"
export * from "./positionAdd.vue?vue&type=script&lang=js"
import style0 from "./positionAdd.vue?vue&type=style&index=0&id=c23f2a7e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c23f2a7e",
  null
  
)

export default component.exports